"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { AlertDialog, AlertDialogAction, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
interface ShareViewTourUnavailableDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}
export function ShareViewTourUnavailableDialog(t0) {
  const $ = _c(5);
  const {
    open,
    onOpenChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AlertDialogHeader><AlertDialogTitle>No shareable views available</AlertDialogTitle><AlertDialogDescription>This workspace does not have any active dashboard views that support sharing yet. Activate a shareable view in workspace settings, then try this tour again.</AlertDialogDescription></AlertDialogHeader>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AlertDialogContent>{t1}<AlertDialogFooter><AlertDialogAction type="button">Got it</AlertDialogAction></AlertDialogFooter></AlertDialogContent>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onOpenChange || $[3] !== open) {
    t3 = <AlertDialog onOpenChange={onOpenChange} open={open}>{t2}</AlertDialog>;
    $[2] = onOpenChange;
    $[3] = open;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}